/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { AllasStandaloneRelatedArticleSlider as ResolvedStandaloneRelatedArticleSlider } from 'sites/allas/components/standalone/RelatedArticleSlider';

export const RelatedArticleSlider: typeof ResolvedStandaloneRelatedArticleSlider = withStandaloneInstanceof((props) => {
    return (
        <ResolvedStandaloneRelatedArticleSlider {...props} />
    );
});

export type RelatedArticleSliderProps = PropsFromComponent<typeof RelatedArticleSlider>;

/** @deprecated Use slot architecture instead */
export const RelatedArticleSliderWith = (extras: DynamicStandaloneExtras): typeof RelatedArticleSlider => {
    return function RelatedArticleSlider(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'RelatedArticleSlider');
        return <ResolvedStandaloneRelatedArticleSlider {...mergeProps({ options: { theme } }, props)} />;
    }
}